module.exports = __webpack_public_path__ + "img/admin-dashboard.89384e21.svg";